import React from "react";
import { TooltipHandle } from "../../common/Tooltip/Tooltip";

export const MenuContext = React.createContext<TooltipHandle | undefined>(
	undefined,
);
